export const withdrawRequestDetails = {
	drawerTitle: "Solicitud del tipo {{type}}",
	successNotification: "solicitud cancelada con éxito",
	errorNotification: "error al cancelar notificación",
	cancelWithdrawPlaceConfirmationButtonLabel: "Cancelar confirmación",
	confirmWithdrawButtonLabel: "Confirmar solicitud",
	cancelWithdrawRequestButtonLabel: "Cancelar solicitud",
	sections: {
		summary: {
			title: "Resumen de la Solicitud",
			fields: {
				place: "Place",
				timestamp: "Fecha/Hora",
				employee: "Empleado",
			},
		},
		details: {
			title: "Detalles de la Solicitud",
			requestedValue: "Valor solicitado",
			anticipatedValue: "Valor anticipado",
			proRata: "Pro-Rata",
			totalValue: "Valor bruto total",
			bankAccount: "Cuenta bancaria",
			obs: "Observación",
			paymentMethod: "Método de pago",
			attachments: "Anexos",
		},
	},
	valueLabel: "Valor:",
};
